<script setup>
defineOptions({
  name: 'AuthLayout',
})
</script>

<template>
  <div class="relative min-h-screen bg-dss-secondary-500 overflow-hidden">
    <div class="absolute inset-0">
      <img
        src="@shared/assets/svg/plus-bg.svg?url"
        :alt="$t('core.layout.background-alt')"
        class="relative object-cover h-full"
        aria-hidden="true"
      >
    </div>

    <div class="relative z-10 flex min-h-screen">
      <div class="w-[850px]">
        <router-view />
      </div>
    </div>
  </div>
</template>
